<template>
    <v-dialog
        :value="isOpen"
        max-width="1400px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <template>
                    <h1 class="text-subtitle-1">
                        Proszę wybrać powód.
                    </h1>
                </template>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col v-if="isDelayed">
                            <v-card elevation="2">
                                <v-card-title>
                                    <h1 class="text-subtitle-1">
                                        <template>
                                            <strong>Spóźnienia</strong>
                                        </template>
                                    </h1>
                                </v-card-title>
                                <v-card-text>
                                    <v-container class="pa-0">
                                        <v-row>
                                            <v-col v-for="(item, index) in delayCommentCodes" :key="index" cols="auto">
                                                <div class="my-2">
                                                    <v-btn
                                                        color="grey"
                                                        x-large
                                                        dark
                                                        rounded
                                                        :class="{
                                                            'button-size-70': item.isSelected || !item.isSelected,
                                                            'success': item.isSelected,
                                                        }"
                                                        class="button-size-70"
                                                        @click="updateDelayComment(item)"
                                                    >
                                                        {{ item.description }}
                                                    </v-btn>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col v-if="isAmountIncomplete">
                            <v-card elevation="2">
                                <v-card-title>
                                    <h2 class="text-subtitle-1">
                                        <template>
                                            <strong>Zaraportowania niepełnego nakładu</strong>
                                        </template>
                                    </h2>
                                </v-card-title>
                                <v-card-text>
                                    <v-container class="pa-0">
                                        <v-row>
                                            <v-col v-for="(item, index) in amountCommentCodes" :key="index" cols="auto">
                                                <div class="my-2">
                                                    <v-btn
                                                        color="grey"
                                                        x-large
                                                        dark
                                                        rounded
                                                        :class="{
                                                            'button-size-70': item.isSelected || !item.isSelected,
                                                            'success': item.isSelected,
                                                        }"
                                                        class="button-size-70"
                                                        @click="updateAmountComments(item)"
                                                    >
                                                        {{ item.description }}
                                                    </v-btn>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose()"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Potwierdź"
                    @click="onSave()"
                >
                    Potwierdź
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators'

export default {
    name: 'ReportFinishCommentCodeDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        reportData: {
            type: Object,
            default: null
        },
        commentCodes: {
            type: Array,
            default: () => []
        },
        codeTypeId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            report: null,
            commentCodeDescription: null,
            amountComments: [],
            delayComments: [],
            amountCommentCodes: [],
            delayCommentCodes: [],
            delayCommentHeaders: [
                {
                    text: 'Opis',
                    align: 'left',
                    sortable: false,
                    value: 'description'
                },
            ],
            amountCommentHeaders: [
                {
                    text: 'Opis',
                    align: 'left',
                    sortable: false,
                    value: 'description'
                },
            ]
        }
    },
    validations: {
        delayComments : {
            required: requiredIf(function() {
                return this.delayComments.length === 0 && this.isDelayed
            })
        },
        amountComments : {
            required: requiredIf(function() {
                return this.amountComments.length === 0 && this.isAmountIncomplete
            })
        },
    },
    computed: {
        isDelayed() {
            return this.codeTypeId === null || this.codeTypeId === 1
        },
        isAmountIncomplete() {
            return this.codeTypeId === null || this.codeTypeId === 2
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.report = JSON.parse(JSON.stringify(this.reportData))
                this.setCommentCodesData()
            } else {
                this.report = {}
                this.amountComments = [],
                this.delayComments = [],
                this.commentCodeDescription = null
                this.$v.$reset()
            }
        }
    },
    methods: {
        updateDelayComment(item) {
            this.delayCommentCodes.map(comment => {
                if (comment.id !== item.id) {
                    comment.isSelected = false
                }
            })
            const index = this.delayCommentCodes.findIndex((comment => comment.id === item.id))

            this.delayCommentCodes.splice(index, 1, {...item, isSelected: true})
            this.delayComments = []
            this.delayComments.push(item)
        },
        updateAmountComments(item) {
            this.amountCommentCodes.map(comment => {
                if (comment.id !== item.id) {
                    comment.isSelected = false
                }
            })
            const index = this.amountCommentCodes.findIndex((comment => comment.id === item.id))

            this.amountCommentCodes.splice(index, 1, {...item, isSelected: true})
            this.amountComments = []
            this.amountComments.push(item)
        },
        setCommentCodesData() {
            switch (this.codeTypeId) {
                case 1:
                    this.delayCommentCodes = this.commentCodes.filter(comment => comment.codeTypeId === 1)
                    this.commentCodeDescription = 'spóźnienia'
                    break
                case 2:
                    this.amountCommentCodes = this.commentCodes.filter(comment => comment.codeTypeId === 2)
                    this.commentCodeDescription = 'zaraportowania niepełnego nakładu'
                    break
                default:
                    this.delayCommentCodes = this.commentCodes.filter(comment => comment.codeTypeId === 1)
                    this.amountCommentCodes = this.commentCodes.filter(comment => comment.codeTypeId === 2)
                    this.commentCodeDescription = 'zaraportowania niepełnego nakładu oraz opóźnienia'
            }

            this.delayCommentCodes.map(comment => comment.isSelected = false)
            this.amountCommentCodes.map(comment => comment.isSelected = false)
        },
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: `Proszę wybrać powód ${this.commentCodeDescription}.`
                })

                return
            }

            const delayComments = this.delayComments.map(item => ({commentCodeId : item.id}))
            const amountComments = this.amountComments.map(item => ({commentCodeId : item.id}))

            this.report.comments = [...this.report.comments, ...delayComments, ...amountComments]

            this.$emit('on-save', this.report)
        },
        onClose() {
            this.$emit('on-close')
        },
    }
}
</script>

